import React, { Component } from "react";
import ReactHtmlParser from 'react-html-parser';
import Select from 'react-select';
import {FeedingController} from '../controllers/Feeding';
import '../styles/feeding.css';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";

export default class CustomModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mealFoodList: null,
      mealData: {
        meal_feeding: null,
        meal_food_list: [],
      }
    }
  }

  onbMealFedChange = (e) => {
    const mealData = this.state.mealData;
    const option= e.target.value;
    const response = FeedingController.showMealList(option, this.props.translation);
    mealData.meal_feeding = option;
    this.setState({ mealFoodList: response, mealData: mealData });
  }

  onMealFoodListChange= (data) => {
    const mealData = this.state.mealData;
    if(data.length !== 0){
      mealData.meal_food_list = data;
    }
    this.setState({mealData: mealData});
  }

  render() {
    const { toggle, onUpdate, onSave, Child, translation } = this.props;
    return (
      <div className="col-md-12 col-sm-12 col-xs-12">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <Modal isOpen={true} toggle={toggle} style = {{padding: "0px", margin: "0px", marginTop: "195px"}} id="food_list">
            <div className="modal-dialog" style = {{padding: "0px", margin: "0px"}}>
              <div className="col-md-12 col-sm-12 col-xs-12" style = {{padding: "0px", margin: "0px"}}>
                <div className="modal-content" style={{marginTop: "",borderRadius: "0px",backgroundColor: "hsl(120, 50%, 40%)"}}>
                  <div className="modal-header">
                    <div className="modal-title" style={{textAlign: "center"}}>{translation['feeding_practice_mealfeed_option_label']}</div>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <select id="meal_feeding" name="meal_feeding" className="form-control" onChange={this.onbMealFedChange}>
                        <option value="">{translation['feeding_practice_mealfeed_empty_option']}</option>
                        <option value={translation['yes_option']}>{translation['yes_option']}</option>
                        <option value={translation['no_option']}>{translation['no_option']}</option>
                      </select>
                      <span id="meal_feeding_error"></span>
                    </div>
                    {this.state.mealFoodList !== null ? (
                      <div className="app">
                        <div className="container-fluid">
                                      <div className="row">
                                        <div className="col-12 col-sm-12 col-md-12 px-0">
                                          <div className="form-group">
                                          <Select options={this.state.mealFoodList} isMulti onChange={(opt) => this.onMealFoodListChange(opt)} />
                                          </div>
                                        </div>
                                      </div>
                        </div>
                      </div>
                      // <div style={{display: 'flex', justifyContent: 'center'}}>
                      //   <MultiSearchSelect searchable={true} showTags={true} multiSelect={true} width="500px" onChange={this.onMealFoodListChange} options={ReactHtmlParser(this.state.mealFoodList)}/>
                      // </div>
                    // <div id="food_list2">
                    //   <div class="form-group">
                    //     <label class="form-control-label text-center">{translation['feeding_practice_mealfeed_value_label']}</label>
                    //     <select name="feeding[]" class="3col active" multiple id="feeding" onChange = {this.onMealFoodListChange}>
                    //       {ReactHtmlParser(this.state.mealFoodList)}
                    //     </select>
                    //   </div>
                    // </div>
                    ) : null}
                    <div className="modal-footer">
                      <button onClick = {toggle} style={{marginRight: "20px",height: "30px",width: "70px"}}>{translation['feeding_practice_mealfeed_cancel_button']}</button>
                      <button onClick={() => onSave(this.state.mealData)} style={{height: "30px",width: "70px"}} id="feeding_food">{translation['feeding_practice_mealfeed_save_button']}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>  
        </div> 
          {/* </div> */}
      </div>
    );
  }
}